import "./App.scss";
import Nav from "./components/Nav";
import Cart from "./components/Cart";

function App() {
  return (
    <>
      <Nav />
      <Cart />
    </>
  );
}

export default App;
